// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-tutorials-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #ffffff;
  min-height: 100vh;
}

.header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f09502;
}

.title {
  color: #333;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
}

.loading-container p {
  margin-top: 1rem;
  color: #666;
  font-size: 1.1rem;
}

.tutorials-form {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tutorials-list {
  margin-bottom: 2rem;
}

.tutorial-item {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #f09502;
}

.tutorial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.tutorial-number {
  color: #333;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
}

.remove-btn {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.form-group {
  margin-bottom: 1rem;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.form-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #f09502;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
}

.form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='m5.8 4.6 2 2L9.4 7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

textarea.form-control {
  resize: vertical;
  min-height: 80px;
}

.video-preview {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}

.video-preview h6 {
  color: #333;
  font-weight: 600;
  margin-bottom: 1rem;
}

.video-container {
  position: relative;
  width: 100%;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-container iframe {
  display: block;
  width: 100%;
  height: 200px;
  border: none;
}

.tutorial-divider {
  margin: 2rem 0 1rem 0;
  border: 0;
  border-top: 1px solid #dee2e6;
}

.actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}

.add-tutorial-btn {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
}

.add-tutorial-btn:hover {
  background-color: #5a6268;
  border-color: #545b62;
  color: white;
}

.save-btn {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
}

.save-btn:hover {
  background-color: #218838;
  border-color: #1e7e34;
  color: white;
}

.save-btn:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  opacity: 0.65;
  cursor: not-allowed;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  text-decoration: none;
  cursor: pointer;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}

.btn-danger:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  opacity: 0.65;
  cursor: not-allowed;
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.text-primary {
  color: #007bff !important;
}

.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .edit-tutorials-container {
    padding: 1rem;
  }

  .title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .tutorials-form {
    padding: 1rem;
  }

  .tutorial-item {
    padding: 1rem;
  }

  .tutorial-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .actions-container {
    flex-direction: column;
    gap: 1rem;
  }

  .add-tutorial-btn,
  .save-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .edit-tutorials-container {
    padding: 0.5rem;
  }

  .tutorials-form {
    padding: 0.5rem;
  }

  .tutorial-item {
    padding: 0.75rem;
  }

  .video-container iframe {
    height: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/edit-tutorials/edit-tutorials.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,yQAAyQ;EACzQ,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qIAAqI;EACrI,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".edit-tutorials-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #ffffff;\n  min-height: 100vh;\n}\n\n.header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #f09502;\n}\n\n.title {\n  color: #333;\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.subtitle {\n  color: #666;\n  font-size: 1.1rem;\n  margin-bottom: 0;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem;\n  text-align: center;\n}\n\n.loading-container p {\n  margin-top: 1rem;\n  color: #666;\n  font-size: 1.1rem;\n}\n\n.tutorials-form {\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tutorials-list {\n  margin-bottom: 2rem;\n}\n\n.tutorial-item {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-left: 4px solid #f09502;\n}\n\n.tutorial-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.tutorial-number {\n  color: #333;\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.remove-btn {\n  font-size: 0.875rem;\n  padding: 0.375rem 0.75rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -0.5rem;\n  margin-left: -0.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-md-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: #f09502;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n}\n\n.form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='m5.8 4.6 2 2L9.4 7'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.invalid-feedback {\n  display: block;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #dc3545;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\ntextarea.form-control {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.video-preview {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.video-preview h6 {\n  color: #333;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.video-container iframe {\n  display: block;\n  width: 100%;\n  height: 200px;\n  border: none;\n}\n\n.tutorial-divider {\n  margin: 2rem 0 1rem 0;\n  border: 0;\n  border-top: 1px solid #dee2e6;\n}\n\n.actions-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 2px solid #e9ecef;\n}\n\n.add-tutorial-btn {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.add-tutorial-btn:hover {\n  background-color: #5a6268;\n  border-color: #545b62;\n  color: white;\n}\n\n.save-btn {\n  background-color: #28a745;\n  border-color: #28a745;\n  color: white;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.save-btn:hover {\n  background-color: #218838;\n  border-color: #1e7e34;\n  color: white;\n}\n\n.save-btn:disabled {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #c82333;\n  border-color: #bd2130;\n}\n\n.btn-danger:disabled {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n.text-primary {\n  color: #007bff !important;\n}\n\n.visually-hidden {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .edit-tutorials-container {\n    padding: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n\n  .tutorials-form {\n    padding: 1rem;\n  }\n\n  .tutorial-item {\n    padding: 1rem;\n  }\n\n  .tutorial-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .col-md-6 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .actions-container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .add-tutorial-btn,\n  .save-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .edit-tutorials-container {\n    padding: 0.5rem;\n  }\n\n  .tutorials-form {\n    padding: 0.5rem;\n  }\n\n  .tutorial-item {\n    padding: 0.75rem;\n  }\n\n  .video-container iframe {\n    height: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
